import React, { useEffect } from "react";
import { Box, Divider, Flex, Stack, Text } from "@chakra-ui/react";
import {
  useColorModeValue,
  Textarea,
  Spinner,
  Portal,
  Image,
  theme,
} from "@chakra-ui/react";
import { Button, IconButton } from "@chakra-ui/react";

import { FaRegHeart, FaRetweet, FaComment } from "react-icons/fa";
import { ExternalLinkIcon, Icon, EditIcon, ViewOffIcon, PlusSquareIcon, CloseIcon } from "@chakra-ui/icons";
import { format, formatDistance } from "date-fns";
import numbro from "numbro";
import styled from "@emotion/styled";
import twitter from "twitter-text";
import { Popover, PopoverTrigger, PopoverContent } from "@chakra-ui/react";
import { hideTweet } from "../../../controllers/bookmark";
import FocusLock from "react-focus-lock";
import { FiMoreVertical } from "react-icons/fi";
import { BsCheckCircle } from "react-icons/bs";

import { BiCopy } from "react-icons/bi";
import { GrLike } from "react-icons/gr";
import { BiLike } from "react-icons/bi";
import UserPopup from "../user-popup";
import { useClipboard } from "@chakra-ui/hooks";
import { useSession } from "next-auth/client";

import { motion } from "framer-motion";
import toast from "react-hot-toast";
import * as analytics from "../../../utils/analytics";
import { CollectionDropdown } from "../../collection-dropdown";
import { firebaseClient, getToken } from "../../../firebaseClient";
import { TweetContext } from "../../../context/tweetContext";
import { BiGhost } from 'react-icons/bi';
import autosize from "autosize";
import { SaveIcon } from "components/icons/SaveIcon";
import { PlusIcon } from "components/icons/PlusIcon";
import { getApiUrl } from "utils/ez4castConfig";
const StyledText = styled(Text)`
  a {
    color: ${() => theme.colors.blue[400]};
  }
`;

const Tweet = ({
  tweet,
  savedTweet = [],
  disableBookmarkButton,
  disableHideButton,
  disableMainHideButton = true,
  refresher = undefined,
  removeTweet = undefined,
  mode = "copy",
  requestVariation = undefined,
  setSelectedTweet = undefined,
  disableRequest,
  isVariation = false,
  disableHeader = false,
  disableFooter = false,
  isEditMode = false,
  disableEditTweet = false,
  disableSubMenu = false,
  disableName = true,
  disableCopy = false,
  disableLike = false,
  isSelectable = false,
  disableCheckmark = true,
  disableUserPopup = false,
  toggleSelection = undefined,
  disableAddToQueue = true,
  forceSelectedTweet = undefined as any,
}) => {
  const { hasCopied, onCopy } = useClipboard(
    // tweet.data.full_text + `\n\nInspired by @${tweet.data.twUserName}`
    tweet.data.full_text
  );
  const [session, loading] = useSession();
  const [isSaved, setIsSaved] = React.useState(false);
  // const [isSelectedInternal, setIsSelectedInternal] = React.useState(false);
  const [isSelected, setIsSelected] = React.useState(false);
  //@ts-ignore
  const inLists = [...new Set(...savedTweet.filter(x => x.id_str === tweet.data.id_str).map(s => s.lists), tweet.data.lists)];
  const initRef = React.useRef(null);

  const [editValue, setEditValue] = React.useState("");
  const [isOpenPopOver, setIsOpenPopOver] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [nbChar, setNbChar] = React.useState<number>(0);
  const [typingTimeout, setTypingTimeout] = React.useState<any>(undefined);

  const openPopOver = () => setIsOpenPopOver(true);
  const closePopOver = () => setIsOpenPopOver(false);
  const tweetContext = React.useContext(TweetContext);
  const refTextArea = React.useRef<any>();

  useEffect(() => {
    //@ts-ignore
    const isSaved = savedTweet.map(tw => tw.id_str).includes(tweet.data.id_str) || tweet?.data?.lists?.length;
    setIsSaved(isSaved);
  }, [savedTweet]);

  useEffect(() => {
    if (isEditMode) {
      setEditValue(tweet.data.full_text);
    }
  }, []);

  React.useEffect(() => {
    if (refTextArea?.current) {
      autosize(refTextArea.current);
      return () => {
        autosize.destroy(refTextArea.current);
      };
    }
    else {
      return;
    }
  }, []);

  // console.log({inLists});
  // entities = JSON.parse(tweet.data.entities),
  // entities = JSON.parse(tweet.data.entities),
  // tweet.data.extended_entities
  // console.log(tweet.data);
  // tweet.data.user.entities = JSON.parse(tweet.data.user.entities);

  if (!tweet.data.fullText) {
    tweet.data.fullText = twitter.autoLink(tweet.data.full_text, {
      //@ts-ignore
      urlEntities: tweet.data?.extended_entities?.urls,
      //@ts-ignore
      mentionEntities: tweet.data?.user_mentions,
      usernameIncludeSymbol: true,
      targetBlank: true,
    });
  }

  if (!tweet.data.fullTextAppended) {
    // tweet.data.fullTextAppended = isVariation ? tweet.data.full_text : tweet.data.full_text + "\n\nInspired by @" + tweet.data.user?.screen_name;
    tweet.data.fullTextAppended = tweet.data.full_text;
  }

  // console.log("render tweet");
  // let isSelected = isSelectedInternal && (!forceSelectedTweet || forceSelectedTweet.id_str === tweet.data.id_str) ;
  // console.log(forceSelectedTweet);

  return (
    <Box key={tweet.data.id} minW="250px"
      bg={useColorModeValue("white", "#1E1E1E")}
      borderWidth={isSelected ? "3px" : "1px"}
      borderColor={isSelected ? "green.300" : useColorModeValue("border.lightMode.light", "border.darkMode.light")}
      // outline={isSelected ? "5px" : "1px"}
      rounded="sm"
      p={2}
      boxShadow="rgba(100, 100, 111, 0.05) 0px 2px 19px 0px;"
      onClick={() => {
        if (isSelectable || toggleSelection) {
          console.log("click tweet");
          // setIsSelectedInternal(!isSelectedInternal);
          if (isSelectable)
            setIsSelected(!isSelected);
          //@ts-ignore
          toggleSelection && toggleSelection(tweet.data);
        }
      }}
      _hover={isSelectable || toggleSelection ? { backgroundColor: "gray.100" } : {}}
      cursor={isSelectable || toggleSelection ? "pointer" : "unset"}
    >
      <Box css={{ filter: tweet.data.isBlurred && "blur(3px)" }}>
        {
          !disableHeader && (
            <>
              <Flex alignItems="center" justifyContent="space-between">
                {
                  isVariation ? (
                    <Box display="flex">
                      <Image
                        key={tweet.data.user.profile_image_url_https}
                        width={8}
                        height={8}
                        borderRadius={20}
                        ml={1}
                        //@ts-ignore
                        src={tweet.data.user.profile_image_url_https}
                      />
                      {
                        !disableName && (
                          <Flex ml={3} flexDirection="column">
                            <Text fontSize={12} color={theme.colors.gray[500]} fontWeight="600" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" width="90px">
                              {tweet.data.user.name}
                            </Text>
                            <Text as="a" href={"https://twitter.com/" + tweet.data.user.screen_name} target="_blank" fontSize={11} color={theme.colors.gray[400]} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" width="90px">
                              {"@" + tweet.data.user.screen_name}
                            </Text>
                          </Flex>
                        )
                      }
                    </Box>
                  ) : (
                    <>
                      <Stack isInline alignItems="center">
                        {
                          !disableUserPopup ? (
                            <Popover isLazy lazyBehavior="unmount" flip={false} trigger="hover" eventListeners={{ scroll: false, resize: false }} offset={[140, 0]}  >
                              <PopoverTrigger>
                                <motion.div
                                  initial={{ opacity: 0 }}
                                  animate={{ opacity: 1 }}
                                  transition={{ delay: 1 }}
                                >
                                  <Image
                                    key={tweet.data.user.profile_image_url_https}
                                    width={8}
                                    height={8}
                                    borderRadius={20}
                                    ml={1}
                                    //@ts-ignore
                                    src={tweet.data.user.profile_image_url_https}
                                    onError={async () => {
                                      console.log("Error loading image for user: " + tweet.data.user.id_str);
                                      let url = `${getApiUrl("refreshAccount")}?id=${tweet.data.user.id_str}`
                                      const token = await getToken(session, "linkedinPost");
                                      let res = fetch(url, {
                                        method: 'GET',
                                        headers: {
                                          'Content-Type': 'application/json',
                                          Authorization: `Bearer ${token}`,
                                          tokenuserid: session?.user?.uid ?? "",
                                        },
                                      }).catch(e => {
                                        console.log("Error refresh account");
                                      });
                                    }}
                                  />
                                </motion.div>
                              </PopoverTrigger>

                              <Portal>
                                <PopoverContent border="0" zIndex={4} width={[300, 300]} boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" css={{ margin: "0", marginTop: 0, marginBottom: 0, webkitMarginStart: 0, marginInlineStart: 0, padding: 0 }}>
                                  <UserPopup user={tweet.data.user} tweet={tweet.data} />
                                </PopoverContent>
                              </Portal>
                            </Popover>
                          ) : (
                            <motion.div
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ delay: 1 }}
                            >
                              <Box display="flex">
                                <Image
                                  key={tweet.data.user.profile_image_url_https}
                                  width={10}
                                  height={10}
                                  borderRadius={20}
                                  ml={1}
                                  //@ts-ignore
                                  src={tweet.data.user.profile_image_url_https}
                                />
                                <Flex ml={3} flexDirection="column">
                                  <Text fontSize={12} color={theme.colors.gray[500]} fontWeight="600" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" width="140px">
                                    {tweet.data.user.name}
                                  </Text>
                                  <Text noOfLines={1} wordBreak="break-all" maxWidth="110px" fontSize={12} color={theme.colors.gray[400]} mt={1} mr={1}>
                                    {
                                      formatDistance(new Date(tweet.data.created_at), new Date(), { addSuffix: true })
                                    }
                                  </Text>
                                </Flex>
                              </Box>
                            </motion.div>
                          )
                        }
                        {
                          mode == "answer" ? (
                            <Flex maxWidth="100px" alignItems="center">
                              <Text mt={1} ml={2} mr={2} fontSize="md">{numbro(tweet.data.user.followers_count).format({
                                // mantissa: 1,
                                average: true,
                                // totalLength: 3,
                              }).replace(".0", "")}</Text>
                              <Text mt={2} fontSize="11px" color="gray.400">Followers</Text>
                            </Flex>
                          ) : (
                            <>
                            </>
                          )
                        }
                      </Stack>
                      <Stack isInline alignItems="center" justifyContent="center">
                        {/* <Text noOfLines={1} wordBreak="break-all" maxWidth="110px" fontSize={12} color={theme.colors.gray[400]} mt={1} mr={1}>
                              {
                                //@ts-ignore
                                // format(new Date(tweet.data.created_at), "Pp")
                                mode == "answer" ? 
                                  formatDistance(new Date(tweet.data.created_at), new Date(), { addSuffix: true })
                                : format(new Date(tweet.data.created_at), 'yyyy/MM/dd')
                              }
                            </Text> */}
                        {
                          !disableRequest && (
                            <Box>
                              <IconButton
                                aria-label="Bookmark"
                                color={useColorModeValue("gray.500", "gray.300")}
                                variant={"solid"}
                                size="sm"
                                onClick={async () => {
                                  analytics.log("hit_request_variation", analytics.formatTweet(tweet.data));
                                  //@ts-ignore
                                  tweetContext.requestVariation(tweet.data);
                                }}
                                cursor="pointer"
                                colorScheme={isSaved ? "gray" : "gray"}
                                icon={<BiGhost />}
                                mr={0}
                              />
                            </Box>
                          )
                        }
                        {/* <Tooltip label={isSaved ? "Add/remove this tweet from collections" : "Save tweet for later access."}> */}
                        <Box>
                          {/* {!disableBookmarkButton && (
                                  <CollectionDropdown
                                    inLists={inLists}
                                    refresher={refresher}
                                    tweet={tweet.data}
                                    isOpenPopOver={isOpenPopOver}
                                    closePopOver={closePopOver}
                                    setIsSaved={setIsSaved}
                                    trigger={(
                                      <IconButton
                                        aria-label="Bookmark"
                                        color="twitter.600"
                                        // variant={"secondary"}
                                        // variant="tertiary"
                                        variant={isSaved ? "ghost" : "solid"}
                                        size="sm"
                                        onClick={async () => {
                                          openPopOver();
                                        }}
                                        cursor="pointer"
                                        // as={isSaved ? BsBookmarksFill : BsBookmarks}
                                        colorScheme={isSaved ? "gray" : "gray"}
                                        icon={
                                          <Icon fill={isSaved ? theme.colors.orange[300] : theme.colors.gray[300]}>
                                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><defs></defs><title>star-flat</title><path d="M505.68,207,386.23,326.48,426,485.4a21.38,21.38,0,0,1-8.64,22.82A21.68,21.68,0,0,1,405.32,512,21.06,21.06,0,0,1,392.95,508L256,410.21,119.05,508a21.16,21.16,0,0,1-24.42.21A21.38,21.38,0,0,1,86,485.4l39.78-158.92L6.32,207a21.18,21.18,0,0,1-4.69-23.25,21.43,21.43,0,0,1,19.73-13.12H177.18L236.06,13.87a21.28,21.28,0,0,1,39.89,0l58.87,156.79H490.64a21.43,21.43,0,0,1,19.73,13.12A21.18,21.18,0,0,1,505.68,207Z"/><g><path d="M505.68,207,386.23,326.48,426,485.4a21.38,21.38,0,0,1-8.64,22.82A21.68,21.68,0,0,1,405.32,512,21.06,21.06,0,0,1,392.95,508L256,410.21V0a21.33,21.33,0,0,1,19.94,13.87l58.87,156.79H490.64a21.43,21.43,0,0,1,19.73,13.12A21.18,21.18,0,0,1,505.68,207Z"/></g></svg>
                                          </Icon>
                                        }
                                        mr={0}
                                      />
                                    )}
                                  />
                                )} */}
                        </Box>
                        {/* </Tooltip> */}
                      </Stack>
                    </>
                  )
                }

              </Flex>
              <Divider my={2} />
            </>
          )
        }
        {
          isEditMode ? (
            <>
              <Textarea
                ref={refTextArea}
                resize={"vertical"}
                minHeight="180px"
                minWidth="280px"
                placeholder="The tweet text"
                value={editValue}
                onChange={(e) => {
                  setIsSaving(true);
                  setEditValue(e.target.value);
                  setNbChar(twitter.parseTweet(e.target.value).weightedLength);

                  if (typingTimeout) {
                    clearTimeout(typingTimeout);
                  }

                  let newTimeout: any = setTimeout(async () => {
                    setIsSaving(true);
                    analytics.log("hit_save_edit_tweet", analytics.formatTweet(tweet.data));
                    const db = firebaseClient.firestore();
                    tweet.data.variations[tweet.data.index] = e.target.value;
                    console.log(tweet.data.variations);
                    //@ts-ignore
                    await db.collection("variations").doc(tweet.data.idVariation).update({ variations: tweet.data.variations });
                    setIsSaving(false);
                  }, 1000);

                  setTypingTimeout(newTimeout);
                }}
              />
              <Box display="flex" justifyContent="space-between" minHeight={10}>
                {
                  isSaving ? (
                    <Box ml={1}>
                      <Spinner size="xs" color="gray.400" />
                    </Box>
                  ) : (
                    <Text
                      align="right"
                      color="gray.400"
                      fontSize="sm"
                      as="i"
                    >
                      saved
                    </Text>
                  )
                }
                <Text
                  align="right"
                  color={nbChar > 280 ? "red" : "gray"}
                  fontWeight={nbChar > 280 ? "bold" : "regular"}
                  fontSize="sm"
                >
                  {nbChar} / 280
                </Text>
              </Box>
            </>
          ) : (
            !disableCopy ? (
              <Box
                as="span"
                onClick={() => {
                  navigator.clipboard.writeText(tweet.data.fullTextAppended);
                  analytics.log("hit_copy_clipboard", analytics.formatTweet(tweet.data));
                  toast.success("Post copied to clipboard", {
                    style: {
                      background: "gray.600",
                      color: "#222",
                    },
                  });
                }}
              >
                <StyledText
                  p={1}
                  pl={3}
                  pr={2}
                  whiteSpace="pre-wrap"
                  dangerouslySetInnerHTML={{
                    __html: tweet.data.fullText,
                  }}
                />
              </Box>
            ) : (
              <StyledText
                p={1}
                pl={3}
                pr={2}
                whiteSpace="pre-wrap"
                dangerouslySetInnerHTML={{
                  __html: tweet.data.fullText,
                }}
              />
            )
          )
        }
        {tweet.data?.extended_entities?.media && tweet.data?.extended_entities?.media?.length > 0 && (
          <Box w="100%" display="flex">
            {
              tweet.data?.extended_entities?.media.map((media, index) => (
                <Box key={tweet.data.id_str + index}>
                  <Image
                    objectFit="cover"
                    p={2}
                    src={media.media_url_https}
                  />
                </Box>
              ))
            }
          </Box>
        )}
        {
          !disableFooter && (
            <>
              <Divider my={2} />
              <Flex alignItems="center" justifyContent="space-between">
                {
                  !isVariation ? (
                    <Box display="flex" flexDir="row">
                      {
                        !disableLike && (
                          <Flex alignItems="center" mr={3} ml={3}>
                            <Box mr={2} as={GrLike} color={theme.colors.blue[600]} />
                            {numbro(tweet.data.favorite_count).format({
                              // mantissa: 1,
                              average: true,
                              totalLength: 1,
                            }).replace(".0", "")}
                          </Flex>
                        )
                      }
                      {
                        (
                          (tweet.data.commentCount || tweet.data.commentCount === 0) && (
                            <Flex alignItems="center">
                              <Box mr={2} as={FaComment} color={theme.colors.green[300]} />
                              {numbro(tweet.data.commentCount).format({
                                // mantissa: 1,
                                average: true,
                                totalLength: 1,
                              }).replace(".0", "")}
                            </Flex>
                          )
                        )
                      }
                    </Box>
                  ) : (
                    <Box>
                    </Box>
                  )
                }
                <Stack isInline spacing={1} alignItems="center">
                  {
                    isEditMode && false && (
                      <Button
                        mr={2}
                        size="sm"
                        onClick={async () => {
                          if (nbChar <= 280) {
                            setIsSaving(true);
                            analytics.log("hit_save_edit_tweet", analytics.formatTweet(tweet.data));
                            const db = firebaseClient.firestore();
                            console.log(tweet.data.variations);
                            tweet.data.variations[tweet.data.index] = editValue;
                            //@ts-ignore
                            await db.collection("variations").doc(tweet.data.idVariation).update({ variations: tweet.data.variations });
                            setIsSaving(false);
                            toast.success("Tweet saved", { style: { background: "gray.600", color: "#222" } });
                          }
                          else {
                            toast.error("Tweet too long", { style: { background: "gray.600", color: "#222" } });
                          }

                        }}
                        isLoading={isSaving}
                        leftIcon={SaveIcon}
                      >
                        {"Save"}
                      </Button>
                    )
                  }
                  {
                    !disableMainHideButton && (
                      <Button
                        variant={"secondary"}
                        size="sm"
                        _hover={{
                          colorScheme: "red",
                          bg: "red.500",
                          color: "white",
                        }}
                        leftIcon={<Icon as={CloseIcon} fontSize="xs" />}
                        onClick={async () => {
                          analytics.log("hit_hide_tweet", analytics.formatTweet(tweet.data));
                          //@ts-ignore
                          removeTweet(tweet.data);
                          hideTweet(tweet.data, session?.user?.uid, -1);
                        }}
                      >
                        {"Hide"}
                      </Button>
                    )
                  }
                  {
                    !disableAddToQueue && (
                      <Button
                        bg="gray.600"
                        variant={"primary"}
                        color="white"
                        mr={0}
                        display="flex"
                        flexDirection="column"
                        leftIcon={PlusIcon}
                        onClick={async () => {
                          analytics.log("hit_tweet_addInQueue_generated", {});
                          // let dataToSend = { 
                          //     idUser: session?.user?.uid, 
                          //     id: tweetContext.id,
                          //     //@ts-ignore
                          //     text: tweetContext.refComposer.current.textState().text, 
                          //     isScheduled: true, 
                          //     scheduledTime: nextSlot,
                          //     isAutoPlug: isAutoPlug,
                          //     autoPlugTrigger: autoPlugTrigger,
                          //     isAutoRetweet: isAutoRetweet,
                          //     autoRetweetHours: autoRetweetHours,
                          //     autoPlugText: "autoPlugText",
                          //     isRetweeted: false,
                          //     isPlugged: false,
                          // }
                          // await scheduleTweet(undefined, setIsOpenConfirm, dataToSend, session?.user?.data?.timezone);
                        }}
                      >
                        <Text>
                          Add to Queue
                        </Text>
                      </Button>
                    )
                  }
                  {
                    mode == "answer" ? (
                      // <Button
                      //   variant={"secondary"}
                      //   size="sm"
                      //   _hover={{
                      //     colorScheme:"twitter", 
                      //     bg:"#1A91DA",
                      //     color:"white",
                      //   }}
                      //   target="_blank"
                      //   as="a"
                      //   //@ts-ignore
                      //   href={`https://twitter.com/${tweet.data.twUserName}/status/${tweet.data.id_str}`}
                      //   onClick={() => {
                      //     analytics.log("hit_answer", analytics.formatTweet(tweet.data));
                      //   }}
                      // >
                      //   {"Answer"}
                      // </Button>
                      <>
                      </>
                    ) : (
                      !disableEditTweet ? (
                        // <Tooltip label={session?.user?.uid ? "Open the scheduler and prefil with this tweet" : "You need to be signed up to tweet"}>
                        <Box>
                          <Button
                            variant={"secondary"}
                            size="sm"
                            _hover={{
                              colorScheme: "twitter",
                              bg: "#1A91DA",
                              color: "white",
                            }}
                            isDisabled={!session?.user?.uid}
                            // target="_blank"
                            // as="a"
                            //@ts-ignore
                            // href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(tweet.data.fullTextAppended)}`}
                            onClick={() => {
                              analytics.log("hit_edit_and_tweet", analytics.formatTweet(tweet.data));
                              // console.log("hit_edit_and_tweet");
                              // console.log("tweet.data.fullTextAppended: " + tweet.data.fullTextAppended);

                              tweet.data.isVariation = isVariation;

                              //@ts-ignore
                              tweetContext.newTweet({ text: tweet.data.fullTextAppended });
                              //@ts-ignore
                              tweetContext.setSelectedTweet(tweet.data);
                              //@ts-ignore
                              tweetContext.open();
                            }}
                          >
                            {"Edit & tweet"}
                          </Button>
                        </Box>
                        // </Tooltip>
                      ) : (
                        <>
                        </>
                      )
                    )
                  }
                  {
                    !disableCheckmark && (
                      <>
                        {/* toto */}
                        {/* <BsCheckCircle fontSize="14px" /> */}
                        <IconButton
                          aria-label="checkmark"
                          color={isSelected ? "green.300" : "gray.200"}
                          variant="tertiary"
                          size="lg"
                          height="30px"
                          colorScheme={isSaved ? "gray" : "gray"}
                          icon={<BsCheckCircle fontSize="24px" />}
                        />
                      </>
                    )
                  }
                  {
                    !disableSubMenu && (
                      <Popover isLazy lazyBehavior="unmount" initialFocusRef={initRef} placement="bottom" offset={[-77, 4]} eventListeners={{ scroll: false, resize: false }}>
                        {({ isOpen, onClose }) => (
                          <>
                            <PopoverTrigger>
                              <IconButton
                                aria-label="Bookmark"
                                color="twitter.600"
                                variant="tertiary"
                                size="xs"
                                height="30px"
                                width="10px"
                                colorScheme={isSaved ? "gray" : "gray"}
                                icon={<FiMoreVertical fontSize="14px" />}
                                mr={1}
                                onClick={() => {
                                  // setSelectedTweet(tweet.data);
                                }}
                              />
                            </PopoverTrigger>

                            <Portal>
                              <PopoverContent _focus={{ outline: "none" }} border="0" zIndex={4} width={[210, 210]} boxShadow="rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;" css={{ margin: 0, marginTop: 0, marginBottom: 0 }}>
                                <FocusLock returnFocus persistentFocus={false}>
                                  <Stack p={2} justifyContent="left" textAlign="left" justifySelf="left">
                                    <Box
                                      as="span"
                                      onClick={() => {
                                        navigator.clipboard.writeText(tweet.data.fullTextAppended);
                                        analytics.log("hit_copy_clipboard", analytics.formatTweet(tweet.data));
                                        toast.success("Post copied to clipboard", {
                                          style: {
                                            background: "gray.600",
                                            color: "#222",
                                          },
                                        });
                                      }}
                                    >
                                      <Button
                                        leftIcon={<BiCopy />}
                                        onClick={() => {
                                          analytics.log("hit_open_tweet", analytics.formatTweet(tweet.data));
                                          onClose();
                                        }}
                                        justifyContent="left"
                                      >
                                        Copy / Paste
                                      </Button>
                                    </Box>
                                    {
                                      !isVariation && (
                                        <Button
                                          leftIcon={<ExternalLinkIcon />}
                                          as="a"
                                          target="_blank"
                                          //@ts-ignore
                                          href={tweet.data.type == "linkedin" ? tweet.data.postUrl : `https://twitter.com/${tweet.data.twUserName}/status/${tweet.data.id_str}`}
                                          onClick={() => {
                                            analytics.log("hit_open_tweet", analytics.formatTweet(tweet.data));
                                            onClose();
                                          }}
                                          justifyContent="left"
                                        >
                                          {tweet.data.type == "linkedin" ? "See on Linkedin" : "See on X"}
                                        </Button>
                                      )
                                    }
                                    {
                                      !disableHideButton && removeTweet && !isVariation && (
                                        <Button
                                          leftIcon={<ViewOffIcon />}
                                          onClick={async () => {
                                            analytics.log("hit_hide_tweet", analytics.formatTweet(tweet.data));
                                            //@ts-ignore
                                            removeTweet(tweet.data);
                                            await hideTweet(tweet.data, session?.user?.uid, -1);

                                            onClose();
                                          }}
                                          justifyContent="left"
                                        >
                                          Hide this tweet
                                        </Button>
                                      )
                                    }
                                    {
                                      // session?.user?.data?.isBeta && !disableRequest && !isVariation && (
                                      session?.user?.uid && !disableRequest && !isVariation && (
                                        <Button
                                          leftIcon={<BiGhost />}
                                          onClick={async () => {
                                            analytics.log("hit_request_variation", analytics.formatTweet(tweet.data));
                                            //@ts-ignore
                                            tweetContext.requestVariation(tweet.data);
                                            onClose();
                                          }}
                                          justifyContent="left"
                                        >
                                          Request variations
                                        </Button>
                                      )
                                    }
                                  </Stack>
                                </FocusLock>
                              </PopoverContent>
                            </Portal>
                          </>
                        )}
                      </Popover>
                    )
                  }
                </Stack>
              </Flex>
            </>
          )
        }
      </Box>
    </Box>
  );
};

export default Tweet;
